import React, {useEffect, useRef} from 'react'

const CreditMemoChatPanel = ({
                                 isOpen,
                                 onClose,
                                 cin,
                                 createdAt,
                                 companyName,
                                 username,
                                 token

                             }) => {
    const VERTONE_AI_CLIENT_URL = process.env.REACT_APP_VERTONE_AI_URL || 'http://localhost:4200'
    const iframeRef = useRef(null);

    const cleanUsername = username ? username.trim().replace(/\s+/g, '') : 'anonymous'

    const iframeUrl = `${VERTONE_AI_CLIENT_URL}?cin=${encodeURIComponent(cin)}&createdAt=${encodeURIComponent(createdAt)}&username=${encodeURIComponent(cleanUsername)}`

    useEffect(() => {
        if (!isOpen || !token) {
            return;
        }
        const iframe = iframeRef.current;
        if (!iframe) {
            return;
        }
        const handleIframeLoad = () => {
            iframe.contentWindow.postMessage(
                {
                    type: 'AUTH_TOKEN',
                    token: token,
                },
                VERTONE_AI_CLIENT_URL,
            )
        }

        iframe.addEventListener('load', handleIframeLoad)

        return () => {
            iframe.removeEventListener('load', handleIframeLoad)
        };

    }, [isOpen, token, VERTONE_AI_CLIENT_URL]);


    if (!isOpen) return null

    return (
        <>
            {/* Overlay - semi-transparent background */}
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 1000,
                    animation: 'fadeIn 0.25s ease-in-out'
                }}
            />

            {/* Side Panel */}
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    width: '60%',
                    height: '100vh',
                    backgroundColor: '#fff',
                    boxShadow: '-2px 0 10px rgba(0, 0, 0, 0.2)',
                    zIndex: 1001,
                    display: 'flex',
                    flexDirection: 'column',
                    animation: 'slideInFromRight 0.25s ease-in-out'
                }}
            >
                {/* Chat Content - Iframe (Full Height, No Header) */}
                <div style={{
                    flex: 1,
                    overflow: 'hidden',
                    backgroundColor: '#fff',
                    position: 'relative'
                }}>
                    {/* Close Button - Floating Top Left */}
                    <button
                        onClick={onClose}
                        style={{
                            position: 'absolute',
                            top: '10px',
                            left: '10px',
                            padding: '8px 16px',
                            backgroundColor: '#d32f2f',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            zIndex: 10,
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}
                    >
                        ✕ Close
                    </button>

                    <iframe
                        src={iframeUrl}
                        title="Credit Memo AI Chat"
                        style={{
                            width: '100%',
                            height: '100%',
                            border: 'none'
                        }}
                        allow="clipboard-read; clipboard-write"
                        ref={iframeRef}
                    />
                </div>
            </div>

            {/* CSS Animations */}
            <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideInFromRight {
          from {
            transform: translateX(100%);
          }
          to {
            transform: translateX(0);
          }
        }
      `}</style>
        </>
    )
}

export default CreditMemoChatPanel
